import { 
  FETCHING_EMAIL_RATE_LIMITER, 
  SET_EMAIL_RATE_LIMITER, 
  FETCHED_EMAIL_RATE_LIMITER,
  RATE_LIMIT_SET
 } from './ConfigureRateLimiterActions'

const initialState = {
  loading: true,
  emailRateLimiter: 0,
  submittedStatus: 'PENDING'
}

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCHING_EMAIL_RATE_LIMITER:
      return {
        ...state,
        loading: true
      }

    case FETCHED_EMAIL_RATE_LIMITER:
      return {
        ...state,
        loading: false,
        emailRateLimiter: parseInt(action.payload.configurationValue, 10),
        submittedStatus: 'PENDING'
      }

    case SET_EMAIL_RATE_LIMITER:
      return {
        ...state,
        loading: false,
        emailRateLimiter: action.payload
      }

     case RATE_LIMIT_SET:
      return {
        ...state,
        submittedStatus: 'RATE_LIMIT_SET'
      }

    default:
      return state
  }
}
